import React from 'react';
import { workAtDark } from "../../Markup"
import Center from "../../templates/Center";
import DevExperience from './DevExperience'
import InfrastructureEngineer from './InfrastructureEngineer'
import FrontendEngineer from './FrontendEngineer'
import SoftwareEngineer from './SoftwareEngineer'
import SomethingElse from './SomethingElse'

export default ({ title, location }) => {
  return (
    <div className="job-wrapper">
      {body(title)}
      <Center data={workAtDark} />
    </div>
  )
}

let body = (title) => {
  switch (title) {
    case "developer-experience":
      return (<DevExperience />)
    case "infrastructure-engineer":
      return (<InfrastructureEngineer/>)
    case "frontend-engineer":
      return (<FrontendEngineer />)
    case "software-engineer":
      return (<SoftwareEngineer />)
    case "something-else":
      return (<SomethingElse />)
    default:
      return <div><h1>404</h1></div>
  }
}


